/**
 * «Nueva propiedad», «Nuevo curso»: el nombre de un tipo lo escribe el cliente y no dice su
 * género, así que se deduce de la primera palabra con las reglas del castellano y sus
 * excepciones más corrientes. Si se equivoca, el título dice «Nuevo» de algo femenino: nada se
 * rompe.
 */
const MASCULINOS_EN_A = new Set(['día', 'dia', 'mapa', 'problema', 'tema', 'programa', 'idioma', 'sistema', 'clima', 'esquema', 'planeta', 'sofá', 'sofa', 'poema', 'drama', 'cometa', 'pijama'])
const FEMENINOS = new Set(['mano', 'foto', 'moto', 'radio', 'imagen', 'clase', 'llave', 'calle', 'noche', 'gente', 'fuente', 'parte', 'suerte', 'muerte', 'nave', 'flor', 'sal', 'red', 'piel', 'miel', 'ley', 'sede', 'torre', 'base', 'frase', 'tarde', 'leche', 'carne', 'nieve', 'fe'])

export const esFemenino = (singular: string): boolean => {
  const palabra = singular.trim().split(/\s+/)[0]?.toLowerCase() ?? ''
  if (!palabra) return false
  if (FEMENINOS.has(palabra)) return true
  if (MASCULINOS_EN_A.has(palabra)) return false
  return /(a|ión|ion|dad|tad|tud|umbre|sis|itis)$/.test(palabra)
}

/** «Nueva» o «Nuevo» delante del nombre en singular. */
export const nuevoDe = (singular: string): string => `${esFemenino(singular) ? 'Nueva' : 'Nuevo'} ${singular}`
